import { validateCompliance } from "utils";

export const directSupplierFormFields = [
  {
    label: 'Στην επεξεργασία προσωπικών δεδομένων και την άντληση - διασταύρωση στοιχείων από τρίτες πηγές.',
    id: 'terms1',
    name: 'terms1',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τους όρους του παρόντος Προγράμματος.',
    id: 'terms2',
    name: 'terms2',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τις συναλλαγές που προβλέπονται από το Πρόγραμμα για την πώληση των επιδοτούμενων προϊόντων και την εξαργύρωση των επιταγών.',
    id: 'terms3',
    name: 'terms3',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι διαθέτει προς πώληση μόνο τα προϊόντα που τηρούν τα ελάχιστα χαρακτηριστικά του Προγράμματος και σε κάθε περίπτωση, μόνο όσα έχουν λάβει προηγούμενη έγκριση από τον Φορέα Υλοποίησης και Ελέγχου και έχουν ενταχθεί στο ενιαίο μητρώο εγκεκριμένου εξοπλισμού.',
    id: 'terms4',
    name: 'terms4',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι δεν εκδίδει τιμολόγια για την πώληση του επιλέξιμου εξοπλισμού ανά κατηγορία που επιδοτούνται από το Πρόγραμμα, δεδομένου ότι αφορούν ενισχύσεις ιδιωτών και μπορεί να εκδίδει αποκλειστικά αποδείξεις Λιανικής Πώλησης.',
    id: 'terms5',
    name: 'terms5',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Την καλή εκτέλεση της εγκατάστασης του επιλέξιμου εξοπλισμού ανά κατηγορία.',
    id: 'terms6',
    name: 'terms6',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι αποφεύγει αθέμιτες πρακτικές και κάθε ενέργεια εκμετάλλευσης των όρων του Προγράμματος, ενδεικτικά μέσω της διενέργειας εικονικών συναλλαγών με ή χωρίς τη συναίνεση και τη συνεργασία των ωφελούμενων.',
    id: 'terms7',
    name: 'terms7',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τους κανόνες δημοσιότητας του Προγράμματος. Κάνει χρήση του λογότυπου του Προγράμματος, ακολουθεί τις κατευθυντήριες οδηγίες που περιγράφονται στην επίσημη διαδικτυακή πύλη και παραπέμπει σε αυτή, σε κάθε σχετική με το Πρόγραμμα διαφήμιση.',
    id: 'terms8',
    name: 'terms8',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι διατηρεί προς επίδειξη το σύνολο του υλικού τεκμηρίωσης των συναλλαγών (παραστατικά πώλησης και διακίνησης, λογιστικές εγγραφές κλπ.).',
    id: 'terms9',
    name: 'terms9',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι είναι σύμφωνος να συμμετέχει σε τυχόν ελέγχους, διευκολύνοντας τα αρμόδια όργανα και παρέχοντας κάθε αναγκαία σχετική πληροφορία.',
    id: 'terms10',
    name: 'terms10',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: <span>Να <strong>ενημερώνεται</strong>, σε τακτά χρονικά διαστήματα, για την <strong>πορεία</strong> της αίτησής του, για τις <strong>ενέργειες</strong> που απαιτείται να πραγματοποιήσει και τις <strong>προθεσμίες</strong> που τίθενται από το Πρόγραμμα, μέσω της διεύθυνσης ηλεκτρονικού ταχυδρομείου που δηλώνει κατά την υποβολή της αίτησής του στο Πληροφοριακό Σύστημα. Η έγκαιρη ανάγνωση απεσταλμένων μηνυμάτων ηλεκτρονικού ταχυδρομείου είναι σημαντική για την επιτυχή υλοποίηση του έργου και αποτελεί αποκλειστική <strong>ευθύνη</strong> του.</span>,
    id: 'terms11',
    name: 'terms11',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
];

export const indirectSupplierFormFields = [
  {
    label: 'Στην επεξεργασία προσωπικών δεδομένων και την άντληση - διασταύρωση στοιχείων από τρίτες πηγές.',
    id: 'terms12',
    name: 'terms12',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τους όρους του παρόντος Προγράμματος.',
    id: 'terms13',
    name: 'terms13',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι διαθέτει δηλώνει προς πώληση μόνο τα προϊόντα που τηρούν τα ελάχιστα χαρακτηριστικά του Προγράμματος',
    id: 'terms14',
    name: 'terms14',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι αποφεύγει αθέμιτες πρακτικές και κάθε ενέργεια εκμετάλλευσης των όρων του Προγράμματος.',
    id: 'terms15',
    name: 'terms15',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τους κανόνες δημοσιότητας του Προγράμματος. Κάνει χρήση του λογότυπου του Προγράμματος, ακολουθεί τις κατευθυντήριες οδηγίες που περιγράφονται στην επίσημη διαδικτυακή πύλη και να παραπέμπει σε αυτή, σε κάθε σχετική με το Πρόγραμμα διαφήμιση.',
    id: 'terms16',
    name: 'terms16',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: <span>Να <strong>ενημερώνεται</strong>, σε τακτά χρονικά διαστήματα, για την <strong>πορεία</strong> της αίτησής του, για τις <strong>ενέργειες</strong> που απαιτείται να πραγματοποιήσει και τις <strong>προθεσμίες</strong> που τίθενται από το Πρόγραμμα, μέσω της διεύθυνσης ηλεκτρονικού ταχυδρομείου που δηλώνει κατά την υποβολή της αίτησής του στο Πληροφοριακό Σύστημα. Η έγκαιρη ανάγνωση απεσταλμένων μηνυμάτων ηλεκτρονικού ταχυδρομείου είναι σημαντική για την επιτυχή υλοποίηση του έργου και αποτελεί αποκλειστική <strong>ευθύνη</strong> του.</span>,
    id: 'terms17',
    name: 'terms17',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
];

export const directSupplierFieldNames = directSupplierFormFields.map(it => it.name);
export const indirectSupplierFieldNames = indirectSupplierFormFields.map(it => it.name);
